/* eslint-disable func-style */
// const breadcrumbsConfig = {
//   '/users': [{ label: 'Admin Home', path: '/apps/home' }, { label: 'Users' }],
//   '/teams': [{ label: 'Admin Home', path: '/apps/home' }, { label: 'Teams' }],
//   '/teams/call-group/:groupId': [
//     { label: 'Admin Home', path: '/apps/home' },
//     { label: 'Teams', path: '/apps/platform-admin/#/teams' },
//     { label: 'Call Group' },
//   ],
//   '/teams/call-group/:groupId/phone-number': [
//     { label: 'Admin Home', path: '/apps/home' },
//     { label: 'Teams', path: '/apps/platform-admin/#/teams' },
//     {
//       label: 'Call Group',
//       path: '/apps/platform-admin/#/teams/call-group/:groupId',
//     },
//     { label: 'Phone Number' },
//   ],
//   '/teams/call-group/:groupId/call-distribution': [
//     { label: 'Admin Home', path: '/apps/home' },
//     { label: 'Teams', path: '/apps/platform-admin/#/teams' },
//     {
//       label: 'Call Group',
//       path: '/apps/platform-admin/#/teams/call-group/:groupId',
//     },
//     { label: 'Call Distribution' },
//   ],
//   '/teams/call-group/:groupId/voicemail': [
//     { label: 'Admin Home', path: '/apps/home' },
//     { label: 'Teams', path: '/apps/platform-admin/#/teams' },
//     {
//       label: 'Call Group',
//       path: '/apps/platform-admin/#/teams/call-group/:groupId',
//     },
//     { label: 'Voicemail' },
//   ],
//   '/teams/call-group/:groupId/forwarding': [
//     { label: 'Admin Home', path: '/apps/home' },
//     { label: 'Teams', path: '/apps/platform-admin/#/teams' },
//     {
//       label: 'Call Group',
//       path: '/apps/platform-admin/#/teams/call-group/:groupId',
//     },
//     { label: 'Forwarding' },
//   ],
//   '/teams/voicemail/:huntGroupId': [
//     { label: 'Admin Home', path: '/apps/home' },
//     { label: 'Teams', path: '/apps/platform-admin/#/teams' },
//     { label: 'Voicemail' },
//   ],
//   '/roles': [{ label: 'Admin Home', path: '/apps/home' }, { title: 'Roles' }],
// };

const breadcrumbsConfig = {
  '/users': {
    breadcrumbs: [{ title: 'Admin Home', path: '/apps/home' }, 'Users'],
  },
  '/teams': {
    breadcrumbs: [{ title: 'Admin Home', path: '/apps/home' }, 'Teams'],
  },
  '/teams/messaging/:groupId/:team': {
    breadcrumbs: [
      { title: 'Admin Home', path: '/apps/home' },
      { title: 'Teams', path: '/apps/platform-admin/#/teams' },
      'TEAM_NAME',
    ],
  },
  '/teams/voicemail/:huntGroupId': {
    breadcrumbs: [
      { title: 'Admin Home', path: '/apps/home' },
      { title: 'Teams', path: '/apps/platform-admin/#/teams' },
      'Voicemail',
    ],
  },
  '/teams/call-group/:groupId/:team/phone-number': {
    breadcrumbs: [
      { title: 'Admin Home', path: '/apps/home' },
      { title: 'Teams', path: '/apps/platform-admin/#/teams' },
      'TEAM_NAME',
    ],
  },
  '/teams/call-group/:groupId/:team/call-distribution': {
    breadcrumbs: [
      { title: 'Admin Home', path: '/apps/home' },
      { title: 'Teams', path: '/apps/platform-admin/#/teams' },
      'TEAM_NAME',
    ],
  },
  '/teams/call-group/:groupId/:team/voicemail': {
    breadcrumbs: [
      { title: 'Admin Home', path: '/apps/home' },
      { title: 'Teams', path: '/apps/platform-admin/#/teams' },
      'TEAM_NAME',
    ],
  },
  '/teams/call-group/:groupId/:team/forwarding': {
    breadcrumbs: [
      { title: 'Admin Home', path: '/apps/home' },
      { title: 'Teams', path: '/apps/platform-admin/#/teams' },
      'TEAM_NAME',
    ],
  },
  '/roles': {
    breadcrumbs: [{ title: 'Admin Home', path: '/apps/home' }, 'Roles'],
  },
};

export function getBreadcrumbs(path, config = breadcrumbsConfig) {
  const match = Object.keys(config).find((breadcrumbPath) => {
    if (breadcrumbPath.includes('/:')) {
      let isTheSame = true;
      const pathParts = path.split('/');
      const breadcrumbPathParts = breadcrumbPath.split('/');

      if (pathParts.length !== breadcrumbPathParts.length) return false;
      breadcrumbPathParts.forEach((part, i) => {
        if (/^:/.test(part) && pathParts[i]) {
          return;
        }
        isTheSame = part === pathParts[i];
      });

      return isTheSame;
    }
    return path === breadcrumbPath;
  });

  return match ? config[match] : null;
}

export const withParams = (params, config) => {
  const configValues = Object.values(config);
  const breadcrumbs = Object.keys(config)
    .map((p) => {
      const paramKeys = Object.keys(params);
      const paramValues = Object.values(params);

      if (paramValues.length === 0) return p;
      const path = paramKeys.reduce((state, ele, i) => {
        const regexp = new RegExp(`:${ele}`);

        return p.replace(regexp, paramValues[i]);
      }, '');

      return path;
    })
    .reduce((state, ele, i) => {
      return { ...state, [ele]: configValues[i] };
    }, {});

  return breadcrumbs;
};

export default breadcrumbsConfig;
